import Block from "@/components/Block";
import BookingSearchDetails from "@/features/booking/components/BookingSearchDetails";
import BookingSummary from "@/features/booking/components/BookingSummary";
import TabletSummaryCard from "@/features/booking/components/TabletSummaryCard";
import { useLayoutTier } from "@/hooks";

export default function SearchSummaryPanel() {
  const tier = useLayoutTier();

  if (tier === "desktop") {
    return <BookingSummary sx={{ position: "sticky", top: 115 }} />;
  }

  if (tier === "tablet") {
    return <TabletSummaryCard />;
  }

  return (
    <Block sx={{ p: 2 }}>
      <BookingSearchDetails variant="compact" />
    </Block>
  );
}
